var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMyracleRossoflat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 156 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tLogo Myracle Rosso flat\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-desktop_Offering---Serp",
    transform: "translate(-64.000000, -38.000000)",
    fill: "#d9291c",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Header",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Myracle-Rosso-flat",
    transform: "translate(64.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 24 0 1 5.96487352 1 12.4972385 10.1347122 19.0365072 1 25 1 25 24 19.3071358 24 19.3071358 9.51810517 14.1914283 16.6732577 10.8030487 16.6732577 5.7204794 9.51810517 5.7204794 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.868044,1.00143615 C111.014226,1.00143615 114.065511,1.86175693 117,3.61336465 L114.388158,7.61069235 C112.453731,6.3882021 109.278351,5.79311324 107.44904,5.79311324 C105.33504,5.79311324 103.653183,6.42186097 102.326093,7.6780101 C101.035502,8.90050035 100.391666,10.5201653 100.391666,12.5019997 C100.391666,14.4838341 101.035502,16.1034991 102.326093,17.3596482 C103.651723,18.5821384 105.33504,19.2095398 107.44904,19.2095398 C109.276891,19.2095398 112.453731,18.614451 114.388158,17.3919607 L117,21.3892884 C114.061131,23.1395498 111.014226,23.9985242 107.863664,23.9985242 C100.447144,24.0981545 94.8935135,19.1422221 95.0015495,12.5006533 C94.8978934,5.86043098 100.451524,0.903152239 107.868044,1.00143615 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "120 24 120 1 126.420874 1 126.420874 19.2066477 136 19.2066477 136 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "39.0078065 9.52301255 38.9904798 9.55648536 34.4761995 1 28 1 35.9809596 15.1004184 35.9809596 24 42 24 42 15.264993"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "44.9844898 10 50 1 43.653551 1 42 4.18414559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "145.387801 5 145.387801 4.99401377 156 4.99401377 156 0 139 0 139 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "152.559735 14.9953747 152.559735 15 155 15 155 10.0061671 145.43525 10.0061671 145.43525 10 139 10 139 14.9953747"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "152.032323 19 152.032323 19.0044937 139 19.0044937 139 24 156 24 156 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0586952,15.3760461 C69.0638328,14.5196483 70.9288479,11.8890843 70.9288479,8.56391753 C70.9288479,6.33970083 70.1345157,4.5264807 68.5458512,3.12425713 C66.9919065,1.71831413 64.9537617,1 62.5046098,1 L52.0042227,1 L52.0042227,5.79108551 L61.5038356,5.79108551 C63.4026321,5.79108551 64.7158843,6.98920558 64.7158843,8.66713159 C64.7158843,10.4120073 63.4026321,11.5766525 61.5038356,11.5766525 L52,11.5766525 L52,24 L58.0792455,24 L58.0792455,16.367738 L60.2215497,16.367738 L65.1606728,24 L72,24 L66.0586952,15.3760461 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "87.4762584 1 81.559411 1 72 24 78.4433284 24 80.0341856 19.7712692 81.8447666 14.8270572 81.8390595 14.8270572 82.0188335 14.3528591 82.2456911 13.7336123 82.2542518 13.7322176 84.5 7.81032078 87.1609405 14.8270572 87.1480995 14.8270572 88.8345509 19.3444909 88.8416847 19.3444909 90.5923411 24 97 24"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyracleRossoflat);
export default __webpack_public_path__ + "static/media/Logo Myracle Rosso flat.00c72c75.svg";
export { ForwardRef as ReactComponent };